import './assets/css/style.css'
import { BrowserRouter, Route, Routes } from "react-router-dom";
import OfficeOrder from "./components/OfficeOrder";

function App(){
    return(
        <>
        <BrowserRouter>
        <Routes>
        <Route path="/" element={<OfficeOrder />} />
        </Routes>
        </BrowserRouter>
        </>
    )
}

export default App;